<template>
    <div class="empty-content">
        <div class="empty-icon" />
        <div class="empty-text">
            Постройте план развития
        </div>
        <router-link
            :to="{ name: 'profession-categories' }"
            class="blue-button empty-button"
        >
            Добавить обучение
        </router-link>
    </div>
</template>

<script>
export default {
    name: "TimeLineEmptyMobile",
};
</script>

<style lang="scss" scoped>
@import "~@/styles/rem";

.empty {
    &-content {
        display: flex;
        flex-flow: column nowrap;
        justify-content: center;
        align-items: center;
        height: 434px;
        background: #F5F9FC url("~@/assets/images/account-track/empty-timeline-bg-mobile.svg") no-repeat center bottom/contain;
    }

    &-icon {
        width: 56px;
        height: 51px;
        margin-bottom: 18px;
        background: url("~@/assets/images/account-track/icon/empty-timeline-icon.svg") no-repeat center/contain;
    }

    &-text {
        font-weight: 600;
        font-size: 16px;
        line-height: 24px;
        color: #98A0A9;
    }

    &-button {
        width: 256px;
        height: 40px;
        margin: 24px 0 0 0;
        border-radius: 4px;
        font-size: 16px;
        line-height: 24px;

        @include on-xs {
            display: none;
        }
    }
}
</style>